/* eslint-disable no-debugger */

import { GetFileSeriviceUrl } from '@/api/CloudFilmService'
const key_FileServiceUrl = 'fileServiceUrl'
const key_ReportInfo = 'reportInfo'
const key_PhoneNum = 'phoneNum'
const key_IsShowShareBtn = 'isShowShareBtn'
const key_IsShowReportListBtn = 'isShowReportListBtn'
const key_IsLogin = 'isLogin'
const Key_PatientInfo='CloudImagePatientInfo'
const Key_GoBackUrlParms='GoBackUrlParms'
const Key_WXJsApiPayInfo='WXJsApiPayInfo'

/**
 * 设置文件服务地址
 * @param {} value 
 */
export function SetFileServiceUrl(value) {
    localStorage.setItem(key_FileServiceUrl, value)
}
/**
 * 获取文件服务地址
 */
export async function GetFileServiceUrl() {
    let ls_value = localStorage.getItem(key_FileServiceUrl)
    if (!ls_value) {
        await GetFileSeriviceUrl().then(resp => {
            ls_value = resp.Result
            SetFileServiceUrl(ls_value)
        })
    }
    return ls_value
}

export function SetCloudImagePatientInfo(value) {
    localStorage.setItem(Key_PatientInfo, JSON.stringify(value))
}
export function GetCloudImagePatientInfo() {
    const ls_value = localStorage.getItem(Key_PatientInfo)
    if (ls_value) {
        return JSON.parse(ls_value)
    } else {
        return null
    }
}
/**
 * 设置当前报告缓存
 * @param {} value 
 */
export function SetReportInfo(value) {
    localStorage.setItem(key_ReportInfo, JSON.stringify(value))
}
/**
 * 获取当前缓存报告
 */
export function GetReportInfo() {
    const ls_value = localStorage.getItem(key_ReportInfo)
    if (ls_value) {
        return JSON.parse(ls_value)
    } else {
        return null
    }
}

/**
 * 设置当前登录的电话号码缓存
 * @param {} value 
 */
export function SetPhoneNum(value) {
    localStorage.setItem(key_PhoneNum, value)
}
/**
 * 获取当前登录的电话号码缓存
 */
export function GetPhoneNum() {
    return localStorage.getItem(key_PhoneNum)
}

/**
 * 设置是否显示分享按钮缓存
 * @param {} value 
 */
export function SetIsShowShareBtn(value) {
    localStorage.setItem(key_IsShowShareBtn, JSON.stringify(value))
}
/**
 * 获取是否显示分享按钮缓存
 */
export function GetIsShowShareBtn() {
    const ls_value = localStorage.getItem(key_IsShowShareBtn)
    if (ls_value) {
        return JSON.parse(ls_value)
    } else {
        return true
    }
}

/**
 * 设置是否显示报告列表按钮缓存
 * @param {} value 
 */
export function SetIsShowReportListBtn(value) {
    localStorage.setItem(key_IsShowReportListBtn, JSON.stringify(value))
}
/**
 * 获取是否显示报告列表按钮缓存
 */
export function GetIsShowReportListBtn() {
    const ls_value = localStorage.getItem(key_IsShowReportListBtn)
    if (ls_value) {
        return JSON.parse(ls_value)
    } else {
        return false
    }
}

/**
 * 设置是否登录 输入安全码\账号密码\或者非加密分享时 都认为已经登录
 * @param {} value 
 */
export function SetIsLogin(value) {
    localStorage.setItem(key_IsLogin, JSON.stringify(value))
}
/**
 * 获取是否显示报告列表按钮缓存
 */
export function GetIsLogin() {
    const ls_value = localStorage.getItem(key_IsLogin)
    if (ls_value) {
        return JSON.parse(ls_value)
    } else {
        return false
    }
}

export function SetGoBackUrlParms(value) {
    localStorage.setItem(Key_GoBackUrlParms, value)
}

export function GetGoBackUrlParms() {
    return localStorage.getItem(Key_GoBackUrlParms)
}

export function SetWXJsApiPayInfo(value) {
    localStorage.setItem(Key_WXJsApiPayInfo, value)
}

export function GetWXJsApiPayInfo() {
    return localStorage.getItem(Key_WXJsApiPayInfo)
}